import { NetworkResponse } from './useNetwork';

export const unwrap = <T>(apiResponse: NetworkResponse<T>): T => {
  if (!apiResponse.isSuccess) {
    // let React Query see it as a real error
    throw new Error(apiResponse.message ?? 'Unknown server error');
  }

  return apiResponse.result as T;
};
